module.exports = __webpack_public_path__ + "img/item8.ef6a88ae.svg";